import { render, staticRenderFns } from "./GlobalIndex.vue?vue&type=template&id=c641c47c&scoped=true"
import script from "./GlobalIndex.vue?vue&type=script&lang=js"
export * from "./GlobalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c641c47c",
  null
  
)

export default component.exports